import { render, staticRenderFns } from "./task-card.vue?vue&type=template&id=418c0300&scoped=true&"
import script from "./task-card.vue?vue&type=script&lang=js&"
export * from "./task-card.vue?vue&type=script&lang=js&"
import style0 from "./task-card.vue?vue&type=style&index=0&id=418c0300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c0300",
  null
  
)

export default component.exports